/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Logger from '@/services/Logger'

// import HttpProvider from '@/services/HttpProvider'
// import Config from '@/config'
// import { urlResolve } from '@/helpers'
// import Graphql from '@/services/Graphql'

// 18-02-21
// BE EDIT
// Commented out because logic was moved to module AppWord
// the module detect the geoip of the user and redirect to correct path
export async function init ({ ctx, route, redirect, store }) {
  Logger.debug('REDIRECT MIDDLEWARE')
  store.commit('ui/urlCode', route.params.lang)
  if (process.client) {
    let origin = location.origin
    if (origin.startsWith('http://localhost')) {
      origin = process.env.VUE_APP_MAGENTO
    }
    store.commit('storeConfig/setHost', `${origin}`)
  } else {
    let origin = ctx.request.header['bcame_origin'] || process.env.VUE_APP_MAGENTO
    store.commit('storeConfig/setHost', origin)
  }
}
